var Url = '//api.qingcigame.com/';
var QQurl = 'https://static.qcplay.com/kol/jump_03.html'    // 加入qq群
var quantity = '';
var obj = {
    index: function() {
        this.preloading(); // 预加载
        this.bind(); // 绑定
        this.clipboardInfo(); // 复制
    },
    m_index: function() {
        this.m_preloading();
        this.bind(); // 绑定
        this.clipboardInfo(); // 复制
        this.m_tabMain(); // 移动端
        // this.share();
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;

        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.loding_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);
            $('.index').addClass('index-show');
            this.indexSwiper();
            setTimeout(function() {
                $('.bg-box').addClass('bg-ani');
            },500)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '//static.qcplay.com/tideng/appointment/images/pc/m_dt_sz.png',
            '//static.qcplay.com/tideng/appointment/images/pc/m_dt_t.png',
            '//static.qcplay.com/tideng/appointment/images/pc/m_jdt.png',
            '//static.qcplay.com/tideng/appointment/images/pc/m_jdt_role.png',
            // 首页
            '//static.qcplay.com/tideng/appointment/images/pc/title_img.png',
            '//static.qcplay.com/tideng/appointment/images/pc/logo_img.png',
            '//static.qcplay.com/tideng/appointment/images/pc/btn_01.png',
            '//static.qcplay.com/tideng/appointment/images/pc/role/desk_lamp.png',
            '//static.qcplay.com/tideng/appointment/images/pc/role/fog.png',
            '//static.qcplay.com/tideng/appointment/images/pc/role/role_01.png',
            '//static.qcplay.com/tideng/appointment/images/pc/role/role_02.png',
            '//static.qcplay.com/tideng/appointment/images/pc/role/role_03.png',
            '//static.qcplay.com/tideng/appointment/images/pc/role/role_04.png',
            '//static.qcplay.com/tideng/appointment/images/pc/role/role_06.png',
            '//static.qcplay.com/tideng/appointment/images/pc/content_bg_02.png',
            '//static.qcplay.com/tideng/appointment/images/pc/cat_img.png',
            '//static.qcplay.com/tideng/appointment/images/pc/cat_slogan_02.png',
            '//static.qcplay.com/tideng/appointment/images/pc/gift_img.png',
            '//static.qcplay.com/tideng/appointment/images/pc/float_code.png',
            '//static.qcplay.com/tideng/appointment/images/pc/decorate_01.png',
            '//static.qcplay.com/tideng/appointment/images/pc/content_bg_01.jpg',
            '//static.qcplay.com/tideng/appointment/images/pc/content_bg_01_03.jpg',
            '//static.qcplay.com/tideng/appointment/images/pc/content_bg_02.jpg',
            '//static.qcplay.com/tideng/appointment/images/pc/content_bg_03.jpg',
            '//static.qcplay.com/tideng/appointment/images/pc/content_bg_04.jpg',
            '//static.qcplay.com/tideng/appointment/images/pc/content_bg_05.jpg',
            '//static.qcplay.com/tideng/appointment/images/pc/content_bg_06.jpg',
            '//static.qcplay.com/tideng/appointment/images/pc/content_bg_07.jpg',
            '//static.qcplay.com/tideng/appointment/images/pc/content_bg_08.jpg',
            '//static.qcplay.com/tideng/appointment/images/pc/label_all_img.png',
            '//static.qcplay.com/tideng/appointment/images/pc/font_all.png',
            '//static.qcplay.com/tideng/appointment/images/pc/50_fen.png',
            '//static.qcplay.com/tideng/appointment/images/pc/100_fen.png',
            '//static.qcplay.com/tideng/appointment/images/pc/150_fen.png',
            '//static.qcplay.com/tideng/appointment/images/pc/200_fen.png',
            '//static.qcplay.com/tideng/appointment/images/pc/200_fen_02.png',
            '//static.qcplay.com/tideng/appointment/images/pc/decorate_role_01.png',
            '//static.qcplay.com/tideng/appointment/images/pc/decorate_role_02.png',
            '//static.qcplay.com/tideng/appointment/images/pc/float_label.png',



        ]);
    },
    // 首页轮播
    indexSwiper: function() {
        var mySwiper = new Swiper('.swiper-container', {
            direction: 'vertical',
            slidesPerView: 'auto',
            paginationClickable: true,
            spaceBetween: 0,
            mousewheelControl: true,
            resistanceRatio: 0,
            onInit: function(swiper) {
                swiperAnimate(swiper);

                function Ani(btn, page) {
                    $(btn).on('click', function() {
                        mySwiper.slideTo(page, 1000, true);
                    });
                };

                function navLink() {
                    for (var i = 7; i >= 0; i--) {
                        Ani('.nav-0' + i + '', i - 1);
                    };
                }
                navLink();

                $('.return-top').on('click', function() {
                    $('.float-nav li a').removeClass('on');
                    $('.nav-01 a').addClass('on')
                    mySwiper.slideTo(0, 1000, true);
                });

                // 邀请好友
                $('.go-invitation').click(function(event) {
                    close();
                    mySwiper.slideTo(2, 1000, true);
                });

                // 任务悬赏
                $('.go-task').click(function(event) {
                    close();
                    mySwiper.slideTo(3, 1000, true);
                });
            },
            onSlideChangeEnd: function(swiper) {
                swiperAnimate(swiper);
                // console.log(swiper.activeIndex + 1);
                var ac_index = swiper.activeIndex + 1;
                $('.float-nav li a').removeClass('on');
                $('.nav-0' + ac_index + ' a').addClass('on')
                swiperAnimate(swiper);

                if (ac_index == 2) {
                    if (!!window.ActiveXObject || "ActiveXObject" in window) {
                        $(".number").html(quantity)
                    } else {
                        $(".number").html(quantity).numScroll({ time: 3000 });
                    }
                }
            },
        });

        // 关闭动画
        function close() {
            $('.popup_wrap').fadeOut().find('.popup_box').removeClass('ani');
        }

        // 左侧二维码自动显示
        setTimeout(function() {
            $('.float-code').addClass('float-l-ani');
            $('.float-nav').addClass('float-r-ani')
        }, 1000);

        function tabSwiperTwo(swiperClass, swiperPagin, stretchX, depthX) {
            var swiper3 = new Swiper(swiperClass, {
                loop: true,
                autoplay: 3000,
                pagination: '.swiper-pagination',
                effect: 'coverflow',
                grabCursor: true,
                centeredSlides: true,
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                slidesPerView: 'auto',
                coverflow: {
                    rotate: 0, // 旋转的角度
                    stretch: stretchX, // 拉伸   图片间左右的间距和密集度
                    depth: depthX, // 深度   切换图片间上下的间距和密集度
                    modifier: 3, // 修正值 该值越大前面的效果越明显
                }
            });
        }
        if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
            // pc端
            tabSwiperTwo('.swiper-container-02', '.swiper-pagination', '121', '230');
        } else {
            // 移动端
            tabSwiperTwo('.swiper-container-02', '.swiper-pagination', '20', '30');
        }
    },
    // 绑定
    bind: function() {

        // 3. 用户是否已经登录接口
        var isLogin_state = ''; // 是否预约过的状态
        var phone_state = '';

        function isLogin() {
            index = layer.load(2, { shade: [0.1, '#fff'] });
            $.ajax({
                url: Url + 'lantern/book/isLogin',
                type: 'post',
                async: false,
                xhrFields: { withCredentials: true },
                success: function(json) {
                    layer.close(index);
                    isLogin_state = json.data.isLogin
                    phone_state = json.data.phone
                    // console.log(isLogin_state);
                    if (phone_state == '') {
                        $('.acco span').html('提灯者,您好');
                    } else {
                        // 登录状态
                        $('.acco span').html(phone_state).siblings('a').html('注销');
                        $('.appointment-btn').addClass('reserved')
                    }
                    if (isLogin_state == true) {
                        initialize();
                        appoCode = json.data.code



                        // console.log(appoCode);
                        $('#bar').html('api.qingcigame.com/lantern/qrcodeshow/' + appoCode);

                        $('.qq-btn').attr('href',QQurl);
                        $('.wb-btn').attr('href','https://service.weibo.com/share/share.php?url=https%3A%2F%2Fapi.qingcigame.com/lantern/qrcodeshow/' + appoCode + '&title=%e6%8f%90%e7%81%af%e4%b8%8e%e5%9c%b0%e4%b8%8b%e5%9f%8e%e9%a2%84%e7%ba%a6%e6%b4%bb%e5%8a%a8&pic=https://download4.qcplay.com/qcgame-admin/PQMgKiblgvy7l0Lzu0zOb12DgtTRSlkC7wPQapwu.png');
                        $('.qj-btn').attr('href','https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=https%3A%2F%2Fapi.qingcigame.com/lantern/qrcodeshow/' + appoCode + '&title=%e6%8f%90%e7%81%af%e4%b8%8e%e5%9c%b0%e4%b8%8b%e5%9f%8e%e9%a2%84%e7%ba%a6%e6%b4%bb%e5%8a%a8&desc=&summary=&pics=https://download4.qcplay.com/qcgame-admin/PQMgKiblgvy7l0Lzu0zOb12DgtTRSlkC7wPQapwu.png');

                        return false;
                    }
                }
            });
        }
        isLogin();

        // 初始化请求需要的接口
        function initialize() {

            // 任务面板数据初始化
            task();

            // 获取用户的推荐人数
            invitationNum();

            // 兑换物品刷新
            packageList();
        }

        $('.acco').on('click', 'a', function(event) {
            var _this = $(this);
            // 未预约
            if (isLogin_state == false) {
                $('.appointment-wrap').fadeIn();
                openA();
            } else {
                $.ajax({
                    url: Url + 'lantern/book/logout',
                    type: 'post',
                    xhrFields: { withCredentials: true },
                    success: function(json) {
                        // 登录状态退出
                        $('.acco span').html('提灯者,您好');
                        window.location.reload();
                    }
                });
            }
        });

        // 1.请求获取短信验证Ajax
        $('.obtain-verification').on('click', 'a', function() {
            var phone = $('.phone-inp');
            var captcha = $('.captcha-inp');

            if (!phone.val()) {
                layer.msg("请输入手机号", { time: 2000 });
                phone.focus();
                return false;
            }
            if (!captcha.val()) {
                layer.msg("请输入图形验证码", { time: 2000 });
                captcha.focus();
                return false;
            }
            // console.log(phone.val())
            // console.log(captcha.val())
            $.ajax({
                url: Url + 'message/sms',
                type: "POST",
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    mobile: phone.val(),
                    channel: "sms",
                    captcha: captcha.val(),
                },
                dataType: 'json',
                success: function(json) {
                    if (json.code == 200) {
                        layer.msg(json.message, { time: 1000 });
                        time();
                    } else {
                        layer.msg(json.message, { time: 2000 });
                    }
                }
            });
        });

        // 2.点击更新图片验证码
        $('.obtain-img').click(function() {
            obtainCaptcha();
        });

        function obtainCaptcha() {
            var timestamp = Date.parse(new Date());
            $('.obtain-img').find("img").attr("src", Url + "image/captcha?channel=sms&r=" + timestamp);
        }

        var wait = 60; // 60s倒计时
        function time() {
            if (wait == 0) {
                $('.obtain-verification span a').remove();
                $('.obtain-verification span').html("<a>发送</a>");
                wait = 60;
            } else {
                $('.obtain-verification span a').remove();
                $('.obtain-verification span').html("<b>" + wait + "秒</b>");
                wait--;
                setTimeout(function() {
                    time()
                }, 1000)
            }
        }

        // 11.预约人数
        function numberAppointments() {
            index = layer.load(2, { shade: [0.1, '#fff'] });
            $.ajax({
                url: Url + 'lantern/book/index',
                type: 'post',
                async: false,
                xhrFields: { withCredentials: true },
                success: function(json) {
                    layer.close(index);
                    if (json.code == 200) {
                        quantity = json.data.num;
                        $('.number').html(quantity).numScroll({ time: 3000 });

                        if (!!window.ActiveXObject || "ActiveXObject" in window) {
                            $(".number").html(quantity)
                        } else {
                            $(".number").html(quantity).numScroll({ time: 3000 });
                        }


                        // 达到50w
                        if (quantity >= 500000) {
                            removeClassN();
                            $('.appointment-schedule').addClass('schedule-50').attr('data', '5');
                            return
                        }
                        // 达到40w
                        if (quantity >= 400000) {
                            removeClassN();
                            $('.appointment-schedule').addClass('schedule-40').attr('data', '4');
                            return
                        }
                        // 达到30w
                        if (quantity >= 300000) {
                            removeClassN();
                            $('.appointment-schedule').addClass('schedule-30').attr('data', '3');
                            return
                        }
                        // 达到20w
                        if (quantity >= 200000) {
                            removeClassN();
                            $('.appointment-schedule').addClass('schedule-20').attr('data', '2');
                            return
                        }
                        // 达到10w
                        if (quantity >= 100000) {
                            removeClassN();
                            $('.appointment-schedule').addClass('schedule-10').attr('data', '1');
                            return
                        }

                        // 初始化类名
                        function removeClassN() { for (var i = 0; i < 6; i++) $('.appointment-schedule').removeClass('schedule-0' + i + '') }

                    } else {
                        $('.number').html('暂无数据');
                        layer.msg(json.message, { time: 1000 });
                    }
                }
            });
        }
        numberAppointments();

        $('.appointment-schedule').on('click', '.m-box', function(event) {
            var _this = $(this);
            var _Parent = _this.parents('.appointment-schedule').attr('data');
            // console.log(_Parent);
            if (_Parent == 1) {
                if (_this.hasClass('m-1')) scheduleG(1);
                if (_this.hasClass('m-2')) scheduleG(2);
                if (_this.hasClass('m-3')) scheduleG(3);
                if (_this.hasClass('m-4')) scheduleG(4);
                if (_this.hasClass('m-5')) scheduleG(5);
            }
            if (_Parent == 2) {
                if (_this.hasClass('m-1')) scheduleG(2);
                if (_this.hasClass('m-2')) scheduleG(3);
                if (_this.hasClass('m-3')) scheduleG(4);
                if (_this.hasClass('m-4')) scheduleG(5);
                if (_this.hasClass('m-5')) scheduleG(1);
            }
            if (_Parent == 3) {
                if (_this.hasClass('m-1')) scheduleG(3);
                if (_this.hasClass('m-2')) scheduleG(4);
                if (_this.hasClass('m-3')) scheduleG(5);
                if (_this.hasClass('m-4')) scheduleG(1);
                if (_this.hasClass('m-5')) scheduleG(2);
            }
            if (_Parent == 4) {
                if (_this.hasClass('m-1')) scheduleG(4);
                if (_this.hasClass('m-2')) scheduleG(5);
                if (_this.hasClass('m-3')) scheduleG(1);
                if (_this.hasClass('m-4')) scheduleG(2);
                if (_this.hasClass('m-5')) scheduleG(3);
            }
            if (_Parent == 5) {
                if (_this.hasClass('m-1')) scheduleG(5)
                if (_this.hasClass('m-2')) scheduleG(1)
                if (_this.hasClass('m-3')) scheduleG(2)
                if (_this.hasClass('m-4')) scheduleG(3)
                if (_this.hasClass('m-5')) scheduleG(4)
            }
        });

        // 点击关闭弹窗
        $('.schedule-wrap .close-bg').click(function(event) {
            // 清除一次兑换商品
            for (var i = 1; i < 6; i++) $('.schedule-wrap').find('.popup_content').removeClass('goods-' + i + '');
        });

        function scheduleG(x) {
            $('.schedule-wrap').fadeIn().find('.popup_content').addClass('goods-' + x + '');
            openA();
        }

        // 5.任务面板数据初始化        
        function task() {
            index = layer.load(2, { shade: [0.1, '#fff'] });
            $.ajax({
                url: Url + 'lantern/book/task/index',
                type: 'post',
                xhrFields: { withCredentials: true },
                success: function(json) {
                    layer.close(index);

                    if (json.code == 200) {
                        var _get1 = json.data.data[1]._get; // 参与游戏评分
                        var _get2 = json.data.data[2]._get; // 预约游戏
                        var _get3 = json.data.data[3]._get; // 关注公众号
                        var _get4 = json.data.data[4]._get; // 关注贴吧
                        var _get5 = json.data.data[5]._get; // 关注微博
                        var _get6 = json.data.data[6]._get; // 加入QQ群

                        $('.content-04 .l-t').addClass('status-' + _get1) // 参与游戏评分
                        $('.content-04 .c-box').addClass('status-' + _get2) // 预约游戏
                        $('.content-04 .r-t').addClass('status-' + _get3) // 关注公众号
                        $('.content-04 .l-b').addClass('status-' + _get4) // 关注贴吧
                        $('.content-04 .l-b-2').addClass('status-' + _get5) // 关注微博
                        $('.content-04 .r-b').addClass('status-' + _get6) // 加入QQ群
                    } else {
                        layer.msg(json.message, { time: 1000 });
                    }
                }
            });
        }

        // 6.1，完成数据面板任务
        $('.content-04 .table-box').on('click', '.ani-btn', function(event) {
            // 未预约
            if (isLogin_state == false) {
                $('.appointment-wrap').fadeIn();
                openA();
            } else {
                //打开一个不被拦截的新窗口
                var data = $(this).attr('data');
                index = layer.load(2, { shade: [0.1, '#fff'] });
                $.ajax({
                    url: Url + 'lantern/book/task/store?task_id=' + data,
                    type: 'post',
                    xhrFields: { withCredentials: true },
                    success: function(json) {

                        if (json.code == 200) {
                            setTimeout(function() { task() }, 1000);
                        }
                        setTimeout(function() {
                            if (data == 1) {
                                // 参与游戏评分-taptap
                                window.open('https://www.taptap.com/app/149961')
                            }
                            if (data == 3) {
                                // 微信
                                $('.wx-wrap').fadeIn();
                                openA();
                            }
                            if (data == 4) {
                                // 关注微博
                                window.location.href = 'https://weibo.com/u/7524328000?is_all=1'
                            }
                            if (data == 5) {
                                // 关注贴吧
                                window.open('https://tieba.baidu.com/f?kw=%E6%8F%90%E7%81%AF%E4%B8%8E%E5%9C%B0%E4%B8%8B%E5%9F%8E&fr=index&fp=0&ie=utf-8')
                            }
                            if (data == 6) {
                                // 加入QQ群
                                window.open(QQurl)
                            }
                            // 刷新一次可领取的灯油兑换
                            packageList();
                            layer.close(index);
                        }, 100);
                    }
                });
            }
        });


        // 邀请好友弹窗
        $('.invitation-btn').click(function(event) {
            // 未预约
            if (isLogin_state == false) {
                $('.appointment-wrap').fadeIn();
                openA();
            } else {
                

                // 生成推广二维码
                qrcode();

            }
        });

        // 灯油兑换成功-弹窗
        $('.dh-succ-btn').click(function(event) {
            var _data = $(this).attr('data');

            // 清除一次兑换商品
            for (var i = 1; i < 7; i++) $('.success-wrap').find('i').removeClass('goods-' + i + '');

            $('.success-wrap').fadeIn().find('i').addClass('goods-' + _data + '');
            openA();
        });

        // 邀请好友弹窗
        $('.content-05').on('click', '.btn', function(event) {
            var _this = $(this);
            var package_id = _this.attr('data');
            var catClass = _this.siblings('img').attr('class');

            // 未预约
            if (isLogin_state == false) {
                $('.appointment-wrap').fadeIn();
                openA();
            } else {
                if (_this.hasClass('is_get-false')) {
                    // 道具礼包未兑换过
                    packageStore(package_id, catClass);
                } else {
                    // layer.msg('您已经兑换过拉，亲~', {time: 1000});
                }
            }
        });


        // 9，道具礼包领取接口
        function packageStore(package_id, catClass) {
            index = layer.load(2, { shade: [0.1, '#fff'] });
            $.ajax({
                url: Url + 'lantern/book/package/store?game_id=33&package_id=' + package_id,
                type: 'post',
                xhrFields: { withCredentials: true },
                success: function(json) {
                    layer.close(index);
                    // console.log(json);
                    // 兑换成功后刷新
                    if (json.code == 200) {
                        packageList();
                        if (catClass == 'goods-05') {
                            // 如果是最后一个则这个不一样的弹窗
                            $('.success-wrap').addClass('success-cat-wrap').fadeIn();
                            openA();
                        } else {
                            $('.success-wrap').removeClass('success-cat-wrap').fadeIn();
                            openA();
                        }
                    }
                    // 兑换失败
                    if (json.code == 403) {
                        $('.fail-wrap').fadeIn();
                        openA();
                    }
                }
            });
        }

        // 7.生成推广二维码
        function qrcode() {
            index = layer.load(2, { shade: [0.1, '#fff'] });
            $.ajax({
                url: Url + 'lantern/book/qrcode',
                type: 'get',
                xhrFields: { withCredentials: true },
                success: function(json) {
                    layer.close(index);
                    // console.log(json);
                    // 兑换成功后刷新
                    if (json.code == 200) {
                        $('.code-img').find("img").attr("src", json.data.url);
                        $('.invitation-wrap').fadeIn();
                        openA();
                    } else {
                        layer.msg(json.message, { time: 1000 });
                    }
                    
                }
            });
        }

        // 8.道具礼包接口
        function packageList() {
            index = layer.load(2, { shade: [0.1, '#fff'] });
            $.ajax({
                url: Url + 'lantern/book/package/list?game_id=33&area=TMP',
                type: 'post',
                xhrFields: { withCredentials: true },
                success: function(json) {
                    layer.close(index);
                    if (json.code == 200) {
                        // console.log(json);
                        $('.exchange-box ul').find('li').remove();
                        $.each(json.data.list, function(index, values) {
                            var dtHtml = '<li class="top-li li-' + values.is_get + '">' +
                                '<img class="goods-0' + index + '" src="' + values.picture + '">' +
                                '<i class="i-' + values.score + '"></i>' +
                                '<a class="btn swiper-no-swiping dh-fail-btn is_get-' + values.is_get + '" data="' + values.id + '" href="javascript:;"></a>' +
                                '</li>';
                            $('.exchange-box ul').append(dtHtml);
                        });
                        // 当前可使用的总分数  
                        var scoreNum = json.data.score;
                        if (json.data.score == null) scoreNum = 0
                        $('.lamp-oil-exchange').html(scoreNum);
                    } else {
                        layer.msg(json.message, { time: 1000 });
                    }
                }
            });
        }
        packageList();

        // 点击查看礼包弹窗
        $('.exchange-box').on('click', '.top-li:nth-child(6) img', function() {
            $('.fift-det-wrap').fadeIn();
            openA();
        });

        // 10，获取用户的推荐人数   
        var numberInv = '';

        function invitationNum() {
            index = layer.load(2, { shade: [0.1, '#fff'] });
            $.ajax({
                url: Url + 'lantern/book/invitationNum',
                type: 'post',
                async: false,
                xhrFields: { withCredentials: true },
                success: function(json) {
                    layer.close(index);
                    if (json.code == 200) {
                        // console.log(json);
                        numberInv = json.data.num;
                        // var number = 4;
                        $('.content-03 ul').addClass('clearfix-' + numberInv + '');

                        if (numberInv > 0) {
                            $('.invitation-wrap  .invitation-box').addClass('complete');
                        }

                        // 每个按钮的状态
                        for (var i = 1; i < 5; i++) {
                            $('.content-03 .t-li-0' + i + '').addClass('li-' + json.data.data[i]._get + '')
                                // $('.content-03 .t-li-0'+i+' a').addClass('s-'+json.data.data[i]._get+'');
                            $('.content-03 .t-li-0' + i + ' .state').addClass('state-' + json.data.data[i]._get + '');
                        };

                    } else {
                        layer.msg(json.message, { time: 1000 });
                    }
                }
            });
        }

        // 4.点击预约按钮
        var appoCode = '';
        $('.getAppo-btn').click(function(event) {
            var os = $('.box-type').find('.select').attr('os');
            var phone = $('.phone-inp');
            var captcha = $('.captcha-inp');
            var verification = $('.verification-inp');
            var invitation = $('.invitation-code-inp');
            var from_id = window.location.href.split('?from_id=')[1];
            if (!phone.val()) {
                layer.msg("请输入手机号", { time: 2000 });
                phone.focus();
                return false;
            }
            if (!captcha.val()) {
                layer.msg("请输入图形验证码", { time: 2000 });
                captcha.focus();
                return false;
            }
            if (!verification.val()) {
                layer.msg("请输入短信验证码", { time: 2000 });
                verification.focus();
                return false;
            }
            if (from_id == undefined || from_id == '') {
                from_id = 0
            }
            index = layer.load(2, { shade: [0.1, '#fff'] });
            $.ajax({
                url: Url + 'lantern/book/store',
                type: 'post',
                async: false,
                data: 'phone=' + phone.val() + '&sms_code=' + verification.val() + '&os=' + os + '&from_id=' + from_id,
                xhrFields: { withCredentials: true },
                success: function(json) {
                    layer.close(index);
                    // console.log(json);
                    if (json.code == 200) {
                        close();
                        setTimeout(function() {

                            layer.close(index);
                            // 获取邀请链接
                            appoCode = json.data.code
                            is_new = json.data.is_new

                            // 1 是新预约
                            // 0 是以前就注册过
                            if (is_new == 0) $('.successful-wrap .popup_content').addClass('new_popup_content');
                            $('.successful-wrap').fadeIn();
                            openA();

                            $('#bar').html('api.qcplay.com/lantern/qrcodeshow/' + appoCode);

                            // $('.qq-btn').attr('href','https://connect.qq.com/widget/shareqq/index.html?url=https%3A%2F%2Fapi.qingcigame.com/lantern/qrcodeshow/' + appoCode + '&title=%e6%8f%90%e7%81%af%e4%b8%8e%e5%9c%b0%e4%b8%8b%e5%9f%8e%e9%a2%84%e7%ba%a6%e6%b4%bb%e5%8a%a8&source=%e6%8f%90%e7%81%af%e4%b8%8e%e5%9c%b0%e4%b8%8b%e5%9f%8e%e9%a2%84%e7%ba%a6%e6%b4%bb%e5%8a%a8&desc=&pics=https://download4.qcplay.com/qcgame-admin/PQMgKiblgvy7l0Lzu0zOb12DgtTRSlkC7wPQapwu.png');
                            $('.qq-btn').attr('href',QQurl);
                            $('.wb-btn').attr('href','https://service.weibo.com/share/share.php?url=https%3A%2F%2Fapi.qingcigame.com/lantern/qrcodeshow/' + appoCode + '&title=%e6%8f%90%e7%81%af%e4%b8%8e%e5%9c%b0%e4%b8%8b%e5%9f%8e%e9%a2%84%e7%ba%a6%e6%b4%bb%e5%8a%a8&pic=https://download4.qcplay.com/qcgame-admin/PQMgKiblgvy7l0Lzu0zOb12DgtTRSlkC7wPQapwu.png');
                            $('.qj-btn').attr('href','https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=https%3A%2F%2Fapi.qingcigame.com/lantern/qrcodeshow/' + appoCode + '&title=%e6%8f%90%e7%81%af%e4%b8%8e%e5%9c%b0%e4%b8%8b%e5%9f%8e%e9%a2%84%e7%ba%a6%e6%b4%bb%e5%8a%a8&desc=&summary=&pics=https://download4.qcplay.com/qcgame-admin/PQMgKiblgvy7l0Lzu0zOb12DgtTRSlkC7wPQapwu.png');


                            // 登录状态
                            $('.acco span').html(phone.val()).siblings('a').html('注销');

                            // 获取一次状态
                            isLogin();

                            // 初始化请求需要的接口
                            initialize();
                        }, 500);
                    } else {
                        layer.msg(json.message, { time: 1000 });
                    }
                }
            });
        });

        // 4.1选择操作系统
        $('.box-type').on('click', 'b', function(event) {
            $(this).addClass('select').siblings().removeClass('select');
        });

        //  4.2预约游戏按钮
        $('.appointment-btn, .appo-btn').click(function(event) {
            var _this = $(this);
            if (isLogin_state !== true) {
                $('.appointment-wrap').fadeIn();
                openA();

                obtainCaptcha(); // 验证码刷新
            } else {
                // layer.msg('您已经预约过啦~', {time: 1000});
            }
        });

        $('.introduce-column').on('click', 'li', function(event) {
            var _thisData = $(this).attr('data');
            console.log(_thisData);
            $('.introduce-wrap').fadeIn().find('.popup_content').addClass('popup_content-'+_thisData+'');
            openA();

        });

        // 点击关闭弹窗
        $('.introduce-wrap .close-bg').click(function(event) {
            for (var i = 1; i < 6; i++) {
                $('.popup_content').removeClass('popup_content-'+i+'');
            };
        });

        // 点击关闭弹窗
        $('.close-bg').click(function(event) {
            close();
        });

        // 点击关闭礼包列表页面的弹窗
        $('.invitation-wrap .close-bg').click(function(event) {
            // 关闭一次执行一次礼包
            packageList();
        });

        // 规则弹窗
        $('.float-rule-btn').click(function(event) {
            $('.rule-wrap').fadeIn();
            openA();
        });

        // 兑换记录
        $('.record-rule-btn').click(function(event) {
            var _this = $(this);
            // if(isLogin_state !== true) {
            //     $('.appointment-wrap').fadeIn();
            //     openA();

            //     obtainCaptcha();    // 验证码刷新
            // } else {
            // 查询兑换记录
            exchange();

            // }
        });

        function exchange() {
            index = layer.load(2, { shade: [0.1, '#fff'] });
            $.ajax({
                url: Url + 'lantern/book/exchange/index',
                type: 'post',
                xhrFields: { withCredentials: true },
                success: function(json) {
                    layer.close(index);
                    if (json.code == 200) {
                        // console.log(json.data);
                        $('.record-wrap .popup_content div').find('p').remove();
                        if (json.data.list.length !== 0) {
                            $.each(json.data.list, function(index, values) {
                                var dtHtml = '<p><span>' + values.created_at + '</span><strong>' + values.my_package_name.name + '</strong></p>';
                                $('.record-wrap .popup_content div').append(dtHtml);
                            });
                            $('.record-wrap').fadeIn();
                            openA();
                        } else {
                            var dtHtml = '<p>暂无获奖记录</p>';
                            $('.record-wrap .popup_content div').append(dtHtml);
                            $('.record-wrap').fadeIn();
                            openA();
                        }

                    } else {
                        $('.appointment-wrap').fadeIn();
                        openA();
                    }
                }
            });
        }


        // 开启动画
        function openA() {
            setTimeout(function() {
                if (!!window.ActiveXObject || "ActiveXObject" in window) {
                    $('.popup_box').addClass('ani-ie');
                } else {
                    $('.popup_box').addClass('ani');
                }
            }, 200);
            setTimeout(function() {
                $('.close').addClass('closeAni')
            }, 300);
        }

        // 关闭动画
        function close() {
            $('.popup_wrap').fadeOut().find('.popup_box').removeClass('ani');
        }
    },
    // 复制
    clipboardInfo: function() {
        var clipboard = new Clipboard('.copy-btn');
        clipboard.on('success', function(e) {
            console.info('Action:', e.action);
            console.info('Text:', e.text);
            console.info('Trigger:', e.trigger);
            layer.msg("复制成功", { time: 2000 });
            e.clearSelection();
        });
    },
    // 图片资源预加载
    m_preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;
            // console.log(numbers);

        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.loding_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);
            $('.index').removeClass('landing');
            obj.indexSwiper();
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '//static.qcplay.com/tideng/appointment/images/mobile/m_jdt.png',
            '//static.qcplay.com/tideng/appointment/images/mobile/m_dt_t.png',
            '//static.qcplay.com/tideng/appointment/images/mobile/content_bg_01.jpg',
            '//static.qcplay.com/tideng/appointment/images/mobile/content_bg_01_01.jpg',
            '//static.qcplay.com/tideng/appointment/images/mobile/record_btn.png',
            '//static.qcplay.com/tideng/appointment/images/mobile/banner_title_01.png',
            '//static.qcplay.com/tideng/appointment/images/mobile/role/role_01.png',
            '//static.qcplay.com/tideng/appointment/images/mobile/role/role_02.png',
            '//static.qcplay.com/tideng/appointment/images/mobile/role/role_03.png',
            '//static.qcplay.com/tideng/appointment/images/mobile/role/role_04.png',
            '//static.qcplay.com/tideng/appointment/images/mobile/role/role_06.png',
            '//static.qcplay.com/tideng/appointment/images/mobile/role/desk_lamp.png'
        ]);
    },
    m_tabMain: function() {
        $('.main-wrap').on('click', 'li', function(event) {
            $(this).parent('.main-wrap').hide().siblings().children('ul').eq($(this).index()).addClass('show').siblings().removeClass('show');
        });

        $('.c-ul').on('click', function(event) {
            $('.main-wrap').show().siblings().children('ul').removeClass('show');
        });

        if (/(iphone)/i.test(navigator.userAgent)) {
            //苹果用户-添加app商城跳转
            $('.successful-wrap').addClass('add-app-link');
            return
        };
    },
    share: function() {
        $.ajax({
            url: api + "/wechat/jssdk",
            type: "POST",
            data: {
                uri: window.location.href,
            },
            success: function(json) {
                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    wx.config(json.data);
                    wx.ready(function() {
                        wx.updateAppMessageShareData({
                            title: '中秋博饼，蜗是状元', // 分享标题
                            desc: '快来帮蜗摇骰子！', // 分享描述
                            link: 'https://static.qcplay.com/snail/zqj-2020/help.html?uid=' + config.uid, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/share.jpg', // 分享图标
                            success: function() {}
                        })

                        wx.updateTimelineShareData({
                            title: '中秋博饼，蜗是状元', // 分享标题
                            link: 'https://static.qcplay.com/snail/zqj-2020/help.html?uid=' + config.uid, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/share.jpg', // 分享图标
                            success: function() {
                                // 设置成功
                            }
                        })
                    });
                    return;
                } else {
                    try {
                        setShareInfo({
                            title: '中秋博饼，蜗是状元', // 分享标题
                            summary: '快来帮蜗摇骰子！', // 分享内容
                            pic: 'https://static.qcplay.com/common/share.jpg', // 分享图片
                            url: 'https://static.qcplay.com/snail/zqj-2020/help.html?uid=' + config.uid, // 分享链接
                            // 微信权限验证配置信息，若不在微信传播，可忽略
                            WXconfig: {
                                swapTitleInWX: true, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
                                appId: json.data.appId, // 公众号的唯一标识
                                timestamp: json.data.timestamp, // 生成签名的时间戳
                                nonceStr: json.data.nonceStr, // 生成签名的随机串
                                signature: json.data.signature // 签名
                            }
                        });
                    } catch (err) {}
                }
            }
        })
    },
}